module.exports = __webpack_public_path__ + "media/fonts/garamond/AGaramondPro-Italic-1370cd3a2d49577e272f5831c4b7025e.woff2";